import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { componentLazyImport } from "modules/core/utils/helpers";

import { projectsPrivateRoutesConstants as routesConstants } from "./routesConstants";

// Pages
const ProjectSettings = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectSettings"))
);
const ProjectIntegrations = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectIntegrations"))
);
const ProjectNotifications = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectNotifications"))
);
const ProjectSharedExperiments = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectSharedExperimentsLists"))
);
const ProjectSharedRoadmaps = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectSharedRoadmaps"))
);
const ProjectDetails = lazy(() =>
  componentLazyImport(() => import("../../pages/ProjectDetails"))
);
const Teams = lazy(() =>
  componentLazyImport(() => import("../../pages/Teams"))
);

const ProjectsPrivateRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.teams.path}>
        <Teams />
      </Route>

      <Route path={routesConstants.project_details.path}>
        <ProjectDetails />
      </Route>

      <Route path={routesConstants.shared_roadmaps.path}>
        <ProjectSharedRoadmaps />
      </Route>

      <Route path={routesConstants.shared_experiments_list.path}>
        <ProjectSharedExperiments />
      </Route>

      <Route path={routesConstants.notifications_settings.path}>
        <ProjectNotifications />
      </Route>

      <Route path={routesConstants.integrations_settings.path}>
        <ProjectIntegrations />
      </Route>

      <Route path={routesConstants.settings.path}>
        <ProjectSettings />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default ProjectsPrivateRoutes;
